import partnerClient from "../partnerClient";

export const fetchPartnerDocumentRequests = async (params) => {
  const { data } = await partnerClient.get("/document-requests", { params });
  return data?.data ?? data;
};

export const fetchPartnerDocumentRequest = async (id) => {
  const { data } = await partnerClient.get(`/document-requests/${id}`);
  return data?.data ?? data;
};

export const uploadPartnerDocumentFile = async (requestId, itemId, file) => {
  const body = new FormData();
  body.append("file", file);
  const { data } = await partnerClient.post(
    `/document-requests/${requestId}/items/${itemId}/files`,
    body,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return data?.data ?? data;
};

export const removePartnerDocumentFile = async (requestId, documentId) => {
  const { data } = await partnerClient.delete(
    `/document-requests/${requestId}/files/${documentId}`
  );
  return data?.data ?? data;
};

export const shareDocumentRequestWithClient = async (requestId) => {
  const { data } = await partnerClient.post(`/document-requests/${requestId}/share-link`);
  return data?.data ?? data;
};

export const confirmPartnerDocumentRequest = async (requestId) => {
  const { data } = await partnerClient.post(`/document-requests/${requestId}/confirm`);
  return data?.data ?? data;
};

/**
 * A request the partner raises themselves, for one of their activated clients. Same shape as
 * the office's request (title + named items); the partner then uploads into it or shares its
 * link. Backend: POST /partner/clients/{clientId}/document-requests.
 */
export const createPartnerDocumentRequest = async (clientId, body) => {
  const { data } = await partnerClient.post(`/clients/${clientId}/document-requests`, body);
  return data?.data ?? data;
};
